<template>
    <iframe 
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen class="youtube-video" 
        frameborder="0"
        :src="'https://www.youtube.com/embed/' + src + '?version=3&loop=1&rel=0&showinfo=0&modestbranding=1'"></iframe>
</template>

<script>
export default {
    props:{
        src:{
            type: String,
            required: true
        }
    }
}
</script>

<style>

</style>